// Projects.js
import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: 'Assisted Living',
      description: 'A comprehensive platform to help elderly individuals and caregivers manage health records, appointments, and daily activities with an intuitive interface.',
      image: 'https://images.unsplash.com/photo-1576091160550-112173f7f869?auto=format&fit=crop&w=400&q=80',
      link: 'https://biscaymanor.ca/'
    },
    {
      title: 'Plannit App',
      description: 'A Java-based project planning and scheduling application for teams. Helps organize tasks, track progress, and collaborate efficiently.',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=400&q=80',
      link: 'https://github.com/shreyamsharma/Plannit-App'
    },
    {
      title: 'Segmenting and Analyzing Toronto',
      description: 'A data science project using Python and Jupyter Notebooks to segment and analyze Toronto neighborhoods using machine learning techniques.',
      image: 'https://images.unsplash.com/photo-1553531889-e6cf89d45b50?auto=format&fit=crop&w=400&q=80',
      link: 'https://github.com/shreyamsharma/Segmenting-and-Analyzing-Toronto'
    },
    {
      title: 'MixQueue (MXQ)',
      description: 'A music queue management system that allows users to queue, organize, and share playlists with friends in real-time.',
      image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=400&q=80',
      link: 'https://github.com/shreyamsharma/MixQueue-MXQ-'
    }
  ];

  return (
    <div id="projects" style={{ 
      padding: '4rem 2rem', 
      background: '#FAF7F2',
      color: '#2C1F14'
    }}>
      <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '2rem', color: '#B5624A' }}>Projects</h2>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(2, 1fr)', 
        gap: '2rem', 
        maxWidth: 1200, 
        margin: '0 auto' 
      }}>
        {projects.map((project, index) => (
          <div key={index} className="project-tile" style={{ 
            background: '#FFFFFF', 
            borderRadius: '1rem', 
            boxShadow: '0 4px 20px rgba(44, 31, 20, 0.08)', 
            padding: '2rem', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            border: '1px solid rgba(181, 98, 74, 0.15)'
          }}>
            <img src={project.image} alt={project.title} style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: '0.5rem', marginBottom: '1rem', transition: 'transform 0.3s ease' }} className="project-img" />
            <h3 style={{ margin: '1rem 0 0.5rem', color: '#2C1F14' }}>{project.title}</h3>
            <p style={{ textAlign: 'center', flex: 1, color: '#6B5444' }}>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer" style={{ 
              marginTop: '1rem', 
              background: 'linear-gradient(135deg, #B5624A 0%, #C87B5E 100%)',
              color: '#fff', 
              padding: '0.75rem 1.5rem',
              borderRadius: '2rem',
              textDecoration: 'none', 
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(181, 98, 74, 0.25)'
            }} className="project-link">View Project</a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
